module.exports = __webpack_public_path__ + "img/homeBgi2.ac0e818c.png";